import { apiClient } from './authService';
import { buildDownloadUrl } from './downloadUrl';

const toFormData = ({ file, maxFileSizeMb, sourceJobId, sourceVariant, workspaceId }) => {
  const hasUpload = Boolean(file);
  const hasSource = Boolean(sourceJobId && sourceVariant);
  if (!hasUpload && !hasSource) {
    throw new Error('Background removal job requires an uploaded file or source artifact reference.');
  }
  if (hasUpload && hasSource) {
    throw new Error('Provide either file upload or source artifact reference, not both.');
  }

  const formData = new FormData();
  if (file) {
    formData.append('file', file);
  }
  if (sourceJobId) {
    formData.append('source_job_id', sourceJobId);
  }
  if (sourceVariant) {
    formData.append('source_variant', sourceVariant);
  }
  if (workspaceId) {
    formData.append('workspace_id', workspaceId);
  }

  if (typeof maxFileSizeMb === 'number') {
    formData.append('max_file_size_mb', String(maxFileSizeMb));
  }

  return formData;
};

export const backgroundService = {
  async createJob({
    file = null,
    maxFileSizeMb = 50.0,
    sourceJobId = null,
    sourceVariant = null,
    workspaceId = null,
  }) {
    const formData = toFormData({ file, maxFileSizeMb, sourceJobId, sourceVariant, workspaceId });

    const response = await apiClient.post('/background/remove', formData, {
      timeout: 300000,
    });

    return response.data;
  },

  async getJobStatus(jobId) {
    const response = await apiClient.get(`/background/job/${encodeURIComponent(jobId)}/status`);
    return response.data;
  },

  async getJobResult(jobId) {
    const response = await apiClient.get(`/background/job/${encodeURIComponent(jobId)}/result`);
    return response.data;
  },

  async downloadProcessed(jobId) {
    const response = await apiClient.get(
      `/background/job/${encodeURIComponent(jobId)}/download/processed`,
      {
        responseType: 'blob',
      }
    );
    return response.data;
  },

  buildDownloadUrl(jobId, type = 'processed') {
    if (!jobId) return null;

    const fileType = type === 'original' ? 'original' : 'processed';
    return buildDownloadUrl(`/background/job/${encodeURIComponent(jobId)}/download/${fileType}`);
  },
};

export default backgroundService;
